module.exports = __webpack_public_path__ + "static/media/voicemail.8d55719d.svg";